wbApp.directive('wbContractTemplateCombo', ['$timeout', '$translate', '$filter', 'contractTemplateSvc',
    function ($timeout, $translate, $filter, contractTemplateSvc) {
        
        function formatResult(model) {
            if (!model) { return; }
            
            return "<div class='row'>" +
                        "<div class='col-md-4'>" + $filter('contractTemplateType')(model.contractTemplateType) + "</div>" +
                        "<div class='col-md-8'>" + model.name + "</div>" +
                    "</div>";
        }

        function formatSelection(model) {
            return model.name;
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            priority: 1,
            scope: {
                ngModel: '=',
                showClearButton: '=',
                contractTemplateType: '=?'
            },
            link: function (scope, elm, attrs, controller) {

                function init() {
                    models.$promise.then(function () {
                        $timeout(function () {
                            $(elm).select2({
                                placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_CONTRACT_TEMPLATE'),
                                formatResult: formatResult,
                                formatSelection: formatSelection,
                                dropdownAutoWidth: true,
                                allowClear: !!scope.showClearButton,
                                minimumResultsForSearch: 5,
                                id: function (model) {
                                    return model.id;
                                },
                                data: models,
                                matcher: function (term, text, data) {
                                    return data.name.toUpperCase().indexOf(term.toUpperCase()) >= 0;
                                }
                            });

                            controller.$render();
                        }, 1);

                        controller.$render = function () {
                            elm.select2('val', controller.$viewValue);
                        };

                        elm.on('change', function () {
                            scope.$apply(function () {
                                controller.$setViewValue(elm.select2('val'));
                            });
                        });

                        attrs.$observe('disabled', function (value) {
                            elm.select2('enable', !value);
                        });

                        attrs.$observe('readonly', function (value) {
                            elm.select2('readonly', !!value);
                        });

                        elm.bind("$destroy", function () {
                            elm.select2("destroy");
                        });

                        controller.$render();

                    });
                }

                var models = contractTemplateSvc.getAllWithFilter(false, scope.contractTemplateType);
                models.$promise.then(function() {
                    $timeout(function () {
                        if (!scope.showClearButton && models.length === 1) {
                            controller.$setViewValue(models[0].id);
                        }
                    });
                })

                scope.$on('refreshContractTemplateCombo', function (e, data) {
                    models = contractTemplateSvc.getAllWithFilter(true, scope.contractTemplateType);
                    models.$promise.then(function () {
                        $timeout(function () {
                            var selection = (!data || !data.id) 
                                ? elm.select2('val')
                                : data.id;
                            elm.select2('destroy');
                            init();
                            controller.$setViewValue(selection);
                        });
                    });
                });

                init();                
            }
        }
    }]);